import React, { useState } from 'react';
import { useBalanceReport } from '../hooks/useApi';
import dayjs from 'dayjs';

export default function Reports() {
  const [month, setMonth] = useState(dayjs().format('YYYY-MM'));
  const { data, isLoading } = useBalanceReport(month);

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h1 className="text-2xl font-bold text-gray-900">Raport Bilanc</h1>
        <input
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          className="input-field w-auto"
        />
      </div>

      {isLoading ? (
        <div className="flex justify-center py-8"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div></div>
      ) : (
        <>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="card bg-gradient-to-r from-blue-500 to-blue-600 text-white">
              <p className="text-blue-100">Bileta (numri)</p>
              <p className="text-3xl font-bold">{data?.tickets?.count}</p>
            </div>
            <div className="card bg-gradient-to-r from-green-500 to-green-600 text-white">
              <p className="text-green-100">Shitje Totale</p>
              <p className="text-3xl font-bold">€{data?.tickets?.total_sales?.toFixed(2)}</p>
            </div>
            <div className="card bg-gradient-to-r from-purple-500 to-purple-600 text-white">
              <p className="text-purple-100">Fitim Bruto (TSC)</p>
              <p className="text-3xl font-bold">€{data?.profit?.gross?.toFixed(2)}</p>
            </div>
            <div className={`card bg-gradient-to-r ${data?.profit?.net >= 0 ? 'from-emerald-500 to-emerald-600' : 'from-red-500 to-red-600'} text-white`}>
              <p className="opacity-80">Fitim Neto</p>
              <p className="text-3xl font-bold">€{data?.profit?.net?.toFixed(2)}</p>
            </div>
          </div>

          {/* Details */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Të ardhurat */}
            <div className="card">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">📈 Të Ardhurat</h2>
              <div className="space-y-3">
                <div className="flex justify-between p-3 bg-gray-50 rounded-lg">
                  <span>Total Tarifa (kosto)</span>
                  <span className="font-medium">€{data?.tickets?.total_fare?.toFixed(2)}</span>
                </div>
                <div className="flex justify-between p-3 bg-green-50 rounded-lg">
                  <span>Total TSC (fitim)</span>
                  <span className="font-medium text-green-600">€{data?.tickets?.total_tax?.toFixed(2)}</span>
                </div>
                <div className="flex justify-between p-3 bg-blue-50 rounded-lg border-t-2 border-blue-500">
                  <span className="font-semibold">Total Shitje</span>
                  <span className="font-bold text-blue-600">€{data?.tickets?.total_sales?.toFixed(2)}</span>
                </div>
              </div>
            </div>

            {/* Shpenzimet */}
            <div className="card">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">📉 Shpenzimet</h2>
              <div className="space-y-3">
                {data?.expenses?.by_category?.map((cat, i) => (
                  <div key={i} className="flex justify-between p-3 bg-gray-50 rounded-lg">
                    <span>{cat.name}</span>
                    <span className="font-medium text-red-600">€{parseFloat(cat.total).toFixed(2)}</span>
                  </div>
                ))}
                <div className="flex justify-between p-3 bg-red-50 rounded-lg border-t-2 border-red-500">
                  <span className="font-semibold">Total Shpenzime</span>
                  <span className="font-bold text-red-600">€{data?.expenses?.total?.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Pagesat */}
          <div className="card">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">💰 Lëvizjet e Parasë</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4 bg-green-50 rounded-lg">
                <p className="text-gray-600">Arkëtime nga Klientët</p>
                <p className="text-2xl font-bold text-green-600">€{data?.payments?.from_clients?.toFixed(2)}</p>
              </div>
              <div className="p-4 bg-red-50 rounded-lg">
                <p className="text-gray-600">Pagesa tek Furnitorët</p>
                <p className="text-2xl font-bold text-red-600">€{data?.payments?.to_suppliers?.toFixed(2)}</p>
              </div>
            </div>
          </div>

          {/* Bilanc Final */}
          <div className={`card ${data?.profit?.net >= 0 ? 'bg-green-50 border-green-500' : 'bg-red-50 border-red-500'} border-2`}>
            <div className="text-center">
              <p className="text-gray-600 text-lg">Bilanc Final i Muajit</p>
              <p className={`text-4xl font-bold ${data?.profit?.net >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                €{data?.profit?.net?.toFixed(2)}
              </p>
              <p className="text-gray-500 mt-2">
                (Fitim Bruto €{data?.profit?.gross?.toFixed(2)} - Shpenzime €{data?.expenses?.total?.toFixed(2)})
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
